import { ca } from '@cian/analytics';

export function trackingGoBackToAd() {
  ca('event', {
    name: 'oldevent',
    category: 'NotCompletedAd_popup',
    action: 'Click',
    label: 'retun_to_addForm',
  });
}
export function trackingShowPopup() {
  ca('event', {
    name: 'oldevent',
    category: 'NotCompletedAd_popup',
    action: 'Show',
    label: '',
  });
}
